import { useIntl } from 'react-intl';
import './mobileHome.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import ResponseStatus from './ResponseStatus';
import successIcon from '../../../assets/images/green_success_icon.png';
import failureIcon from '../../../assets/images/device_not_allowed.svg';
import spinnerIcon from '../../../assets/images/spinner.svg';

const MobileHome = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const searchParams = new URLSearchParams(window.location.search);
    const status = searchParams.get('status');
    const msg = searchParams.get('msg');

    return (
        <div className='mobile-page-layout'>
            <div className='mobile-page'>
                <div className='device-header'>
                    <div>{f({ id: 'AI_EDU_SAMSUNG_AI_ASSISTANT' })}</div>
                </div>
                <main className='main'>
                    <div className='message'>
                        {status === 'Success' ? (
                            <ResponseStatus
                                message={msg}
                                responseImg={successIcon}
                            />
                        ) : status === 'Failure' ||
                          status === 'INTERNAL_SERVER_ERROR' ||
                          status === 'INVALID_SESSION_ID' ? (
                            <ResponseStatus
                                message={
                                    status === 'INTERNAL_SERVER_ERROR'
                                        ? f({
                                              id: 'AI_EDU_INTERNAL_SERVER_ERROR',
                                          })
                                        : msg
                                }
                                responseImg={failureIcon}
                            />
                        ) : (
                            <ResponseStatus
                                message={msg}
                                responseImg={spinnerIcon}
                            />
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MobileHome;
